import * as Sentry from '@sentry/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://50774176639c671cc4bc22bc5c4933f8@o4506083880468480.ingest.us.sentry.io/4509848380833792',
  release: environment.version,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/kontorcms\.gitapp\.de/],
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
